import {Image} from '@yandex-delivery/blocks'
import {flow, get, tag2url} from '@yandex-delivery/utils'
import type {FC, ReactElement} from 'react'

import type {IconSpotWidgetProps as Props} from '../types'

export const IconSpotWidget: FC<Props> = //
  flow(
    get('config.icon_spot.icon.image_tag'), //
    tag2url,
    (src: string): ReactElement => <Image alt="" height={24} src={src} />,
  )
IconSpotWidget.displayName = 'IconSpotWidgetDesktop'
